import { render } from "./ForeignTradeByRegionsTable.vue?vue&type=template&id=3b17711f&scoped=true&ts=true"
import script from "./ForeignTradeByRegionsTable.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByRegionsTable.vue?vue&type=script&lang=ts"

import "./ForeignTradeByRegionsTable.vue?vue&type=style&index=0&id=3b17711f&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b17711f"]])

export default __exports__